import { useEffect } from "react";
import { useOutletContext, Link } from "react-router-dom";
import { TabNames } from "../Assets/variables";
import Images from "../Assets/Images/images";
import APIOverviewExample from "./APIOverviewExample";

const APIOverview = () => {
    const {setActiveTabItem, apiInfo} = useOutletContext();

    useEffect(() => {
        setActiveTabItem(TabNames.Overview);
    }, []);
    
    return (
        <>
            <div id="tab-overview" className="api-panel">
                <div className="tab-overview__content">
                    <div className="left-side">
                        <p id="overview-description" dangerouslySetInnerHTML={{ __html: apiInfo.overviewDescription }}></p>
                        <Link
                            id="six-button-trial"
                            className="six-button six-button--action"
                            to={'https://www.six-group.com/en/products-services/financial-information/display-and-delivery-capabilities/six-api/demo.html'}
                            target="_blank">
                            Request a trial
                        </Link>
                    </div>
                    {apiInfo.hasImage &&
                        <div className="right-side">
                            {apiInfo.hasUniquesImage
                                ? <img id="tab-overview__image" src={Images[apiInfo.apiName]} alt={`${apiInfo.apiTitle} overview`} />
                                : <img id="tab-overview__image" src={Images.DefaultAPIImage} alt={`${apiInfo.apiTitle} overview`} />
                            }
                        </div>
                    }
                </div>
                {apiInfo.example &&
                    <>
                        <h4 id="example-title">Example</h4>
                        <div id="tab-overview-example-data">
                            <APIOverviewExample apiInfo={apiInfo} />
                        </div>
                    </>
                }
            </div>
        </>
    );
};

export default APIOverview;